import React, { useEffect, useRef, useState } from "react";
import ReportsTable from "./ReportsTable";
import { TableContext } from "../index";
import { debug } from "../utils";
import { useHistory } from "react-router-dom";
import ReportsTableHeader from "./ReportsTableHeader";
import PaginationManager from "../view/PaginationManager";
import { getReportSchedules, listPageable } from "./reportService";
import { connect } from "react-redux";
import ScheduledReportsTable from "./ScheduledReportsTable";

const SCHEDULE_POLL_INTERVAL_MS = 5000;
const REPORT_TABS = {
    GENERATED: "generated",
    SCHEDULED: "scheduled"
};

function ReportsTableSection({ userRole }) {

    const history = useHistory();
    const scheduleSignatureRef = useRef(null);

    const initTableConfig = {
        selected: [],
        isLoading: true
    }

    const [tableConfig, setTableConfig] = useState(initTableConfig);
    const [activeTab, setActiveTab] = useState(REPORT_TABS.GENERATED);

    const changeTableConfig = (config) => {
        debug("Table config changed:", config);
        setTableConfig(config);
    }

    useEffect(() => {
        if (!userRole || activeTab !== REPORT_TABS.GENERATED) {
            return;
        }

        let cancelled = false;

        const getScheduleSignature = (schedules) => (schedules || [])
            .map((schedule) => schedule.lastScheduledTime || "")
            .filter(Boolean)
            .sort()
            .join("|");

        const refreshWhenScheduleRuns = async () => {
            try {
                const result = await getReportSchedules(userRole);
                const schedules = Array.isArray(result)
                    ? result
                    : Object.values(result || {}).filter((item) => item && typeof item === "object");
                const nextSignature = getScheduleSignature(schedules);

                if (scheduleSignatureRef.current === null) {
                    scheduleSignatureRef.current = nextSignature;
                    return;
                }

                if (nextSignature !== scheduleSignatureRef.current) {
                    scheduleSignatureRef.current = nextSignature;
                    setTableConfig((currentConfig) => ({
                        ...currentConfig,
                        lastUpdated: Date.now()
                    }));
                }
            } catch (err) {
                debug("Report schedule refresh check failed:", err);
            }
        };

        refreshWhenScheduleRuns();
        const intervalId = window.setInterval(() => {
            if (!cancelled) {
                refreshWhenScheduleRuns();
            }
        }, SCHEDULE_POLL_INTERVAL_MS);

        return () => {
            cancelled = true;
            window.clearInterval(intervalId);
        };
    }, [activeTab, userRole]);

    return (
        <TableContext.Provider value={{ config: tableConfig, setConfig: changeTableConfig }}>
            <div className="container-fluid" key={history.location}>
                <div className="row">
                    <div className="col-12">
                        <div className="card oct_analysis-card-v2">
                            <ReportsTableHeader
                                activeTab={activeTab}
                                onTabChange={setActiveTab}
                            />
                            <div className="card-body">
                                <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            {activeTab === REPORT_TABS.GENERATED ? (
                                                <>
                                                    <ReportsTable />
                                                    <PaginationManager getPage={listPageable} />
                                                </>
                                            ) : (
                                                <ScheduledReportsTable />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </TableContext.Provider>
    )
}

function mapStateToProps(state) {
    return {
        userRole: state.auth?.userRole?.name
    };
}

export default connect(mapStateToProps)(ReportsTableSection);
